import React, { useEffect, useMemo, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Field } from "formik";
import { FormGroup, Label, Row, Col, Input, Card, CardBody } from "reactstrap";

import "react-phone-number-input/style.css";
import Title from "../title";
import { store } from "../../redux/storeConfig/store";
import MultiSelector from "../multiSelector";
import { FormatObjects } from "../appointment/bookAppointment/utils";
import { useSelector, useDispatch } from "react-redux";
import { TextWithSelect } from "../textWithSelect";
import { endOptions, startOptions } from "../class/utils";
import {
  getCourtDurations,
  getCourts,
} from "../../redux/actions/api/apiAction";
import ReactSelect from "react-select";
import { customStyle } from "../appointment/utils";
import { TieredPricingInput } from "../../tieredPricingInput";
import { PackagePricing } from "./packagePricing";
import { PeakOffPeakPricing } from "./peakOffPeakPricing";
const cancelationOptions = [
  {
    id: 1,
    label: "Days",
    value: "d",
  },
  {
    id: 2,
    label: "Hours",
    value: "h",
  },
];

export const FormFirstStep = (formikProps) => {
  const dispatch = useDispatch();
  const { packageEdit, editFields } = store.getState().sidebar;
  const { gym, gymConfig } = store.getState().gym;
  const { courtDurations, courts } = store.getState().court;
  const { errors, touched, setFieldValue, values } = formikProps;
  const isHourlyCourtPackage =
    values.memberShipType === "court" && values.courtUsageUnit === "MINUTE";
  const [userRole, setUserRole] = useState("GYM");
  const [restrictGender, setRestrictGender] = useState(false);
  const [hasPoolAccess, setHasPoolAccess] = useState(false);
  const packagePriceUpdatesEnabled = Boolean(
    gymConfig?.manageMemberships?.appointmentMemberships?.enabled &&
      gymConfig?.manageMemberships?.appointmentMemberships?.ptGroupPricing &&
      gymConfig?.manageMemberships?.appointmentMemberships?.ptGroupPricing
      &&gymConfig?.manageMemberships?.appointmentMemberships?.ptGroupPricing
        ?.enabled
  );

  const [nSessions, setNSessions] = useState();
  const [allBranches, setAllBranches] = useState(
    gym &&
      gym.superGymAdmin &&
      gym.superGymAdmin.gyms &&
      gym.superGymAdmin.gyms.length
      ? gym.superGymAdmin.gyms.filter((g) => g.id != gym.id)
      : []
  );

  const branchesList = useMemo(() => FormatObjects(allBranches, "name"), [
    allBranches,
  ]);
  const [customBranchesSelected, setCustomBranchesSelected] = useState([]);
  const [durationsSelected, setDurationsSelected] = useState([]);

  courtDurations.forEach((d) => (d.name = `${d.duration} mins`));

  const durationsList = useMemo(() => FormatObjects(courtDurations, "name"), [
    courtDurations,
  ]);
  const courtList = useMemo(() => FormatObjects(courts, "name"), [courts]);

  useEffect(() => {
    dispatch(getCourtDurations());
    dispatch(getCourts());

    setFieldValue("memberShipType", gym.type == "gym" ? "GYM" : "court");
    if (packageEdit) {
      setFieldValue("title", editFields.name);
      setFieldValue("price", editFields.price);
      setFieldValue(
        "memberShipType",
        editFields.trainer === null ? "GYM" : "PT"
      );
      setFieldValue(
        "pt",
        editFields.trainer === null ? "" : editFields.trainer
      );
      setFieldValue("session", editFields.sessionCount);
      setFieldValue("duration", editFields.durationType);
      setFieldValue(
        "days",
        editFields.durationType === "D"
          ? editFields.durationCount
          : editFields.durationCount / 30
      );
      setFieldValue("mode", editFields.type);
      setFieldValue("description", editFields.description);
    }
    let loginObj = JSON.parse(localStorage.getItem("connectToFitGymPanelUser"));
    let { role, trainer } = loginObj;
    setUserRole(role);
    if (role === "TRAINER") {
      setFieldValue("memberShipType", "PT");
      setFieldValue("pt", trainer);
    }
  }, []);

  React.useEffect(() => {
    if (nSessions) setFieldValue("session", nSessions);
    else setFieldValue("session", 0);

    if( formikProps.values.memberShipType =="pt" &&  gym.type == "sportClub"){
      setFieldValue("capacity",1)
    }
    if (formikProps.values.memberShipType !== "court") {
      setFieldValue("hasPeakOffPeakPricing", false);
      setFieldValue("courtUsageUnit", "SESSION");
    }
  }, [formikProps.values.memberShipType,gym]);

  React.useEffect(() => {
    if (gymConfig?.manageMemberships?.enabled) {
      if (!gymConfig?.manageMemberships?.gymMemberships?.enabled) {
        if (gymConfig?.manageMemberships?.classMemberships?.enabled)
          setFieldValue("memberShipType", "class") 
        else if (gymConfig?.manageMemberships?.appointmentMemberships?.enabled)
          setFieldValue("memberShipType", "pt") 
      }
    }
  }, [gymConfig]);


  return (
    <>
      <div className=" bg-white card-panel add-package-form">
        <div className="basic-info">
          <div className="info-title with-border">
            <Title
              title="Add Package"
              subtitlestyle="ctf-tx-secondary"
              subtitle="Add info about the Package"
            />
          </div>
        </div>
        <div className="info blk-padding-y pb-4 border-bottom-1">
          <Row>
            <Col md={4}>
              <FormGroup className="custom-inputs with-icon mb-xl-0">
                <Field
                  type="text"
                  name="title"
                  id="id"
                  placeholder="Title"
                  className={`form-control ${errors.title &&
                    touched.title &&
                    "is-invalid"}`}
                />
                {errors.title && touched.title ? (
                  <div className="invalid-feedback">{`${errors.title}`}</div>
                ) : null}
                <Label for="name" className="">
                  Package Name
                </Label>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup className="custom-inputs with-icon mb-md-0">
                <Field
                  type="number"
                  name="price"
                  id="id"
                  placeholder="Price"
                  disabled={values.hasPeakOffPeakPricing}
                  className={`form-control ${errors.price &&
                    touched.price &&
                    "is-invalid"}`}
                />
                {errors.price && touched.price ? (
                  <div className="invalid-feedback">{`${errors.price}`}</div>
                ) : null}
                <Label for="price" className="">
                  Price
                </Label>
              </FormGroup>
            </Col>
            {packagePriceUpdatesEnabled &&
              values?.memberShipType === "court" && (
              <Col md={4}>
                <FormGroup className="ml-3 mt-2 mb-0">
                  <Label>
                    <Input
                      type="checkbox"
                      checked={Boolean(values.hasPeakOffPeakPricing)}
                      onChange={(event) =>
                        setFieldValue(
                          "hasPeakOffPeakPricing",
                          event.target.checked
                        )
                      }
                      className="payment-checkbox"
                    />
                    Use peak/off-peak pricing
                  </Label>
                </FormGroup>
              </Col>
            )}
          </Row>
          {packagePriceUpdatesEnabled &&
            values?.memberShipType === "court" &&
            values.hasPeakOffPeakPricing && (
              <PeakOffPeakPricing errors={errors} touched={touched} />
            )}
        </div>
        <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y">
          <div className="info-title pb-0">
            <Title title={"Membership Type"} />
          </div>
          <div className="status-inner-block">
            <div className="status-inner-block">
              {
                gymConfig?.manageMemberships?.gymMemberships?.enabled &&
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      onChange=""
                    >
                      {gym.type == "gym" ? (
                        <>
                          <Field
                            disabled={userRole === "TRAINER"}
                            type="radio"
                            name="memberShipType"
                            id="gymRadio"
                            value="GYM"
                            className="form-check-input no-padding"
                          />

                          <label
                            className="form-check-label label-blk"
                            for="gymRadio"
                          >
                            Gym
                          </label>
                        </>
                      ) : (
                        <>
                          <Field
                            disabled={userRole === "TRAINER"}
                            type="radio"
                            name="memberShipType"
                            id="courtRadio"
                            value="court"
                            className="form-check-input no-padding"
                          />

                          <label
                            className="form-check-label label-blk"
                            for="courtRadio"
                          >
                            {gym.type == "sportClub" ? "Rental Court" : "Room"}
                          </label>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              }
              {
                gymConfig?.manageMemberships?.classMemberships?.enabled &&
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      checked
                      onChange=""
                    >
                      <Field
                        disabled={userRole === "TRAINER"}
                        type="radio"
                        name="memberShipType"
                        id="classRadio"
                        value="class"
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label label-blk"
                        for="classRadio"
                      >
                        {gym.type == "sportClub" ? "Group Session" : "Class"}
                      </label>
                    </div>
                  </div>
                </div>
              }
              {
                gymConfig?.manageMemberships?.appointmentMemberships?.enabled &&
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      checked
                      onChange=""
                    >
                      <Field
                        disabled={userRole === "TRAINER"}
                        type="radio"
                        name="memberShipType"
                        id="appoitmentRadio"
                        value="pt"
                        className="form-check-input no-padding"
                      />
                      <label
                        className="form-check-label label-blk"
                        for="appoitmentRadio"
                      >
                        {gym.type == "sportClub"
                          ? "Private Lesson"
                          : "Appointment"}
                      </label>
                    </div>
                  </div>
                </div>
              }
            </div>
            {errors.memberShipType && touched.memberShipType ? (
              <div
                className="invalid-feedback"
                style={{ display: "block" }}
              >{`${errors.memberShipType}`}</div>
            ) : null}
          </div>
          {(
            <Row className="ml-3 ">
              <Col md={3}>
                <FormGroup className="ml-3 mt-4 mb-n2 ">
                  <Label>
                    <Input
                      type="checkbox"
                      name="in"
                      checked={restrictGender}
                      onChange={(e) => {
                        setRestrictGender(e.target.checked);
                        if (!e.target.checked) {
                          setFieldValue("gender", "");
                        }
                      }}
                      className="payment-checkbox"
                    />
                    Restrict Package Gender
                  </Label>
                </FormGroup>
              </Col>
              {gym.type == "gym" && (
                <>
                  <Col md={3}>
                    <FormGroup className="mt-4 mb-n2 ">
                      <Label>
                        <Input
                          type="checkbox"
                          name="requiredAttachment"
                          checked={values.requiredAttachment}
                          onChange={(e) => {
                            setFieldValue("requiredAttachment", true);
                            if (!e.target.checked) {
                              setFieldValue("requiredAttachment", false);
                            }
                          }}
                          className="payment-checkbox"
                        />
                        Required Attachment
                      </Label>
                    </FormGroup>
                  </Col>

                  {values?.memberShipType == "GYM" && (
                    <Col md={3}>
                      <FormGroup className="ml-n4 mt-4 mb-n2 ">
                        <Label>
                          <Input
                            type="checkbox"
                            name="in"
                            checked={values.hasClassessAccess}
                            onChange={(e) => {
                              setFieldValue(
                                "hasClassessAccess",
                                e.target.checked
                              );
                            }}
                            className="payment-checkbox"
                          />
                          Allow this package to book all classes
                        </Label>
                      </FormGroup>
                    </Col>
                  )}
                  {values?.memberShipType == "class" && (
                    <Col md={3}>
                      <FormGroup className="ml-n4 mt-4 mb-n2 ">
                        <Label>
                          <Input
                            type="checkbox"
                            name="in"
                            checked={values.allowTransfereBookings}
                            onChange={(e) => {
                              setFieldValue(
                                "allowTransfereBookings",
                                e.target.checked
                              );
                            }}
                            className="payment-checkbox"
                          />
                          Allow this package to transfer bookings
                        </Label>
                      </FormGroup>
                    </Col>
                  )}
                  {gymConfig?.manageMemberships?.gymMemberships?.packageOnlyForTrainer && values?.memberShipType == "GYM" && (
                    <Col md={3}>
                      <FormGroup className="ml-n4 mt-4 mb-n2 ">
                        <Label>
                          <Input
                            type="checkbox"
                            name="in"
                            checked={values.isforTrainerOnly}
                            onChange={(e) => {
                              setFieldValue(
                                "isforTrainerOnly",
                                e.target.checked
                              );
                              setFieldValue("session", "unlimited");
                            }}
                            className="payment-checkbox"
                          />
                          Only for trainer{" "}
                        </Label>
                      </FormGroup>
                    </Col>
                  )}
                  {branchesList &&
                    branchesList.length > 0 &&
                    values?.memberShipType == "GYM" && (
                      <Col md={3} style={{ marginLeft: "40px" }}>
                        <FormGroup className="ml-n4 mt-4 mb-n2">
                          <Label>
                            <Input
                              type="checkbox"
                              name="isSharedPackage"
                              checked={values.isSharedPackage}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setFieldValue("isSharedPackage", checked);
                                if (!checked) {
                                  setFieldValue("sharedBranches", []);
                                  setFieldValue(
                                    "packageBranchesSharingType",
                                    "sharedForCustomBranches"
                                  );
                                  setCustomBranchesSelected([]);
                                }
                              }}
                              className="payment-checkbox"
                            />
                            Package Sharable Across Multiple Branches
                          </Label>
                        </FormGroup>
                      </Col>
                    )}
                    {values?.memberShipType == "GYM" && (
                      <>
                        <Col md={3} style={{ marginLeft: "40px" }}>
                          <FormGroup className="ml-n4 mt-4 mb-n2">
                            <Label>
                              <Input
                                type="checkbox"
                                checked={hasPoolAccess}
                                onChange={(e) => {
                                  setHasPoolAccess(e.target.checked);
                                  if (!e.target.checked) {
                                    setFieldValue("poolAccessType", null);
                                  }
                                }}
                                className="payment-checkbox"
                              />
                              Has Pool Access
                            </Label>
                          </FormGroup>
                        </Col>
                      </>
                    )}
                </>
              )}
              {
                (gymConfig?.manageMemberships?.enabled && gymConfig?.manageMemberships?.shareMembershipBetweenFamilyMembers) &&
                <Col md={3}>
                  <FormGroup className="ml-n4 mt-4 mb-n2 ">
                    <Label>
                      <Input
                        type="checkbox"
                        name="in"
                        checked={values.sharedBetweenFamily}
                        onChange={(e) => {
                          setFieldValue("sharedBetweenFamily", e.target.checked);
                        }}
                        className="payment-checkbox"
                      />
                      Shared Between Family Members
                    </Label>
                  </FormGroup>
                </Col>
              }
            </Row>
          )}

          {restrictGender && (
            <>
              <div className="subscription-plan-list-element mt-2">
                <div className="">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    checked
                    onChange=""
                  >
                    <Field
                      type="radio"
                      value="F"
                      name="gender"
                      className="form-check-input no-padding"
                      id="femaleRadio"
                    />
                    <label
                      className="form-check-label label-blk"
                      for="femaleRadio"
                    >
                      Female{" "}
                    </label>
                  </div>
                </div>
              </div>

              <div className="subscription-plan-list-element mt-2">
                <div className="">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    checked
                    onChange=""
                  >
                    <Field
                      type="radio"
                      value="M"
                      name="gender"
                      className="form-check-input no-padding"
                      id="maleRadio"
                    />
                    <label
                      className="form-check-label label-blk"
                      for="maleRadio"
                    >
                      Male{" "}
                    </label>
                  </div>
                </div>
              </div>
            </>
          )}
          {hasPoolAccess && (
            <>
              <div className="subscription-plan-list-element mt-2">
                <div className="">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    checked
                    onChange=""
                  >
                    <Field
                      type="radio"
                      value="pool_only"
                      name="poolAccessType"
                      className="form-check-input no-padding"
                      id="poolOnlyRadio"
                    />
                    <label
                      className="form-check-label label-blk"
                      for="poolOnlyRadio"
                    >
                      Pool Only
                    </label>
                  </div>
                </div>
              </div>

              <div className="subscription-plan-list-element mt-2">
                <div className="">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    checked
                    onChange=""
                  >
                    <Field
                      type="radio"
                      value="gym_and_pool"
                      name="poolAccessType"
                      className="form-check-input no-padding"
                      id="gymPoolRadio"
                    />
                    <label
                      className="form-check-label label-blk"
                      for="gymPoolRadio"
                    >
                      Gym & Pool
                    </label>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {(gym.type == "sportClub" || gym.type == "complex") &&
          values?.memberShipType == "court" && (
            <div className="mt-4">
              <Row>
                <Col md={4}>
                  <FormGroup
                    className="with-icon mb-xl-0"
                    style={{ marginBottom: "0px" }}
                  >
                    {console.log({courtList})}
                    <FormGroup className="custom-inputs mb-md-0 ">
                      <ReactSelect
                        name="court"
                        isMulti
                        className={`form-control custom-inputs p-0 h-100 d-flex align-items-center`}
                        styles={customStyle}
                        options={courtList}
                        value={formikProps.values.courts}
                        onChange={(courts) =>{
                          console.log({courts})
                           formikProps.setFieldValue("courts", courts)
                           
                        }
                        }
                      />
                      <Label for="court">
                        {" "}
                        {gym.type == "sportClub" ? "Court" : "Room"}
                      </Label>
                    </FormGroup>{" "}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    className="with-icon mb-xl-0"
                    style={{ marginBottom: "0px" }}
                  >
                    <MultiSelector
                      name="courtDurations"
                      placeholder="Select Court Durations.."
                      data={durationsList}
                      handleChange={formikProps.setFieldValue}
                      selected={durationsSelected}
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup className="custom-inputs with-icon mb-md-0">
                    <Field
                      type="number"
                      name="capacity"
                      id="capacity"
                      placeholder="Capacity"
                      className={`form-control ${errors.capacity &&
                        touched.capacity &&
                        "is-invalid"}`}
                    />
                    {errors.capacity && touched.capacity ? (
                      <div className="invalid-feedback">{`${errors.capacity}`}</div>
                    ) : null}
                    <Label for="capacity" className="">
                      Capacity
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          )}
          {
            values?.memberShipType === "pt" && packagePriceUpdatesEnabled &&
          <Row className="mb-4">
          <Col lg={4} md={6} className="mb-3">
            <Card className="h-100 border-0 shadow-sm">
              <CardBody className="p-4">
                <Label className="text-secondary mb-2 d-flex align-items-center" style={{ fontWeight: 600 }}>
                  <i className="bi bi-person-lines-fill mr-2 ctf-tx-primary"></i>
                  Maximum Capacity
                </Label>
               
                <FormGroup className="mb-0 mt-3">
                  <Field
                    type="number"
                    name="capacity"
                    id="capacity"
                    placeholder="Enter capacity"
                    min={1}
                    className={`form-control form-control-lg ${
                      formikProps.errors.capacity && formikProps.touched.capacity
                        ? "is-invalid"
                        : ""
                    }`}
                    style={{ fontSize: '1.1rem', fontWeight: 500 }}
                  />
                  {formikProps.errors.capacity && formikProps.touched.capacity && (
                    <div className="invalid-feedback">{formikProps.errors.capacity}</div>
                  )}
                   <small className="text-muted mt-2 d-block">Maximum number of players allowed</small>
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
          <Col lg={8} md={6} className="mb-3">
            <PackagePricing formikProps={formikProps} />
          </Col>
          {/* CONDITIONAL INPUT: STATIC FEE */}
          {formikProps.values.pricingType === "static" && (
            <Col md={6} className="mb-3">
              <Card className="border-0 shadow-sm ctf-tx-primary" >
                <CardBody className="p-4 ctf-tx-primary">
                  <Label className="mb-2 d-flex align-items-center" style={{ fontWeight: 600 }}>
                    <i className="bi bi-plus-circle-fill mr-2"></i>
                    Extra Person Fee
                  </Label>
                  <FormGroup className="mb-0">
                    <div className="input-group input-group-lg">
                      <span className="input-group-text  border-0" style={{ fontWeight: 600 }}>$</span>
                      <Field
                        type="number"
                        name="extraPersonFee"
                        id="extraPersonFee"
                        placeholder="0.00"
                        min={0}
                        step="0.01"
                        className="form-control border"
                        style={{ fontSize: '1.25rem', fontWeight: 600 }}
                      />
                    </div>
                    <small className="d-block mt-2 opacity-75">
                      This fee will be added for each additional person beyond the base
                    </small>
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
          )}
          {/* CONDITIONAL INPUT: TIERED PRICING */}
          {formikProps.values.pricingType === "tiered" && (
            <Col md={12} className="mb-3">
              <TieredPricingInput
                capacity={formikProps.values.capacity}
                basePrice={formikProps.values.price}
                tiers={formikProps.values.tiers || []}
                setTiers={(tiers) => formikProps.setFieldValue("tiers", tiers)}
                setBasePrice={(price) => formikProps.setFieldValue("price", price)}
              />
            </Col>
          )}
        </Row>
          }

        {values.isSharedPackage && (
          <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y">
            <div className="info-title pb-0">
              <Title title={"Shared Package"} />
            </div>
            <div className="status-inner-block">
              <div className="status-inner-block">
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      checked
                      onChange=""
                    >
                      <Field
                        type="radio"
                        name="packageBranchesSharingType"
                        id="sharedForCustomBranches"
                        value="sharedForCustomBranches"
                        className="form-check-input"
                        checked={
                          formikProps.values.packageBranchesSharingType ===
                          "sharedForCustomBranches"
                        }
                        onClick={(e) => {
                          setFieldValue(
                            "packageBranchesSharingType",
                            e.target.value
                          );
                          setFieldValue(
                            "sharedBranches",
                            customBranchesSelected.map((br) => br.value)
                          );
                        }}
                      />
                      <label
                        className="form-check-label label-blk"
                        for="sharedForCustomBranches"
                      >
                        Custom Branches
                      </label>
                    </div>
                  </div>
                </div>
                <div className="subscription-plan-list-element">
                  <div className="radio-perdays-package">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      onChange=""
                    >
                      <Field
                        type="radio"
                        name="packageBranchesSharingType"
                        id="sharedForAllBranches"
                        value="sharedForAllBranches"
                        className="form-check-input"
                        checked={
                          formikProps.values.packageBranchesSharingType ===
                          "sharedForAllBranches"
                        }
                        onClick={(e) => {
                          setFieldValue(
                            "packageBranchesSharingType",
                            e.target.value
                          );
                          const selected = branchesList.filter((br) => {
                            return formikProps.values.sharedBranches.includes(
                              br.value
                            );
                          });
                          if (selected && selected.length) {
                            setCustomBranchesSelected(selected);
                          }
                          setFieldValue(
                            "sharedBranches",
                            branchesList.map((br) => br.value)
                          );
                        }}
                      />

                      <label
                        className="form-check-label label-blk"
                        for="sharedForAllBranches"
                      >
                        Gold Membership (All Branches)
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="info blk-padding-y pb-0">
              <Row>
                <Col md={6}>
                  <FormGroup
                    className="with-icon mb-xl-0"
                    style={{ marginBottom: "0px" }}
                  >
                    {values.packageBranchesSharingType ===
                      "sharedForCustomBranches" && (
                      <MultiSelector
                        name="sharedBranches"
                        placeholder="Select Branches.."
                        data={branchesList}
                        handleChange={(name, selectedValues) => {
                          setFieldValue(name, selectedValues);
                          setCustomBranchesSelected(
                            branchesList.filter((br) =>
                              selectedValues.includes(br.value)
                            )
                          );
                        }}
                        selected={customBranchesSelected}
                      />
                    )}
                    {values.packageBranchesSharingType ===
                      "sharedForAllBranches" && (
                      <MultiSelector
                        name="sharedBranches"
                        placeholder="Select Branches.."
                        data={branchesList}
                        handleChange={formikProps.setFieldValue}
                        selected={[...branchesList]}
                        isDisabled={true}
                      />
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
        )}
        {
          <Row>
            {formikProps.values.memberShipType === "court" && (
              <Col md={6} className="mt-4 mb-4">
                <FormGroup className="custom-inputs with-icon mb-md-0">
                  <Input
                    type="select"
                    name="courtUsageUnit"
                    value={
                      formikProps.values.forMatchMaking
                        ? "MINUTE"
                        : formikProps.values.courtUsageUnit || "SESSION"
                    }
                    disabled={Boolean(formikProps.values.forMatchMaking)}
                    onChange={(e) =>
                      setFieldValue("courtUsageUnit", e.target.value)
                    }
                  >
                    <option value="SESSION">Per booking/session</option>
                    <option value="MINUTE">Per hour (duration based)</option>
                  </Input>
                  <Label for="courtUsageUnit">Court package usage</Label>
                  <small className="text-muted d-block mt-1">
                    {formikProps.values.forMatchMaking
                      ? "A match-making package deducts the full match time. A 60 minute match spends 1 hour."
                      : "Duration-based packages deduct the booked court duration. A single-session package is the drop-off price."}
                  </small>
                </FormGroup>
                <FormGroup check className="mt-3">
                  <Label check className="container-blk">
                    <Input
                      type="checkbox"
                      checked={Boolean(formikProps.values.forMatchMaking)}
                      onChange={(e) => {
                        setFieldValue("forMatchMaking", e.target.checked);
                        if (e.target.checked) {
                          setFieldValue("courtUsageUnit", "MINUTE");
                        }
                      }}
                    />{" "}
                    Match making package
                    <span className="checkmark"></span>
                  </Label>
                </FormGroup>
              </Col>
            )}
            <Col md={6} className="mt-4 mb-4">
              <FormGroup className="custom-inputs with-icon mb-md-0">
                <Field
                  disabled={
                    formikProps.values.session === "unlimited" ||
                    ((gym.type == "sportClub" || gym.type == "complex") &&
                      formikProps.values.session === 1)
                  }
                  type="number"
                  step={isHourlyCourtPackage ? "0.5" : "1"}
                  name="session"
                  placeholder={`${
                    isHourlyCourtPackage
                      ? "Hours"
                      : formikProps.values.memberShipType === "pt" ||
                        formikProps.values.memberShipType === "class"
                      ? "Sessions"
                      : "Visits"
                  }`}
                  min={1}
                  value={nSessions}
                  className={`form-control ${errors.session &&
                    touched.session &&
                    "is-invalid"}`}
                  onChange={(e) => {
                    if (e.target.value !== 0) {
                      setNSessions(e.target.value);
                      setFieldValue("session", e.target.value);
                    } else {
                      setFieldValue("session", "");
                      setNSessions(e.target.value);
                    }
                  }}
                />
                {errors.session && touched.session ? (
                  <div className="invalid-feedback">{`${errors.session}`}</div>
                ) : null}
                <Label for="price" className="">
                  Number of{" "}
                  {`${
                    isHourlyCourtPackage
                      ? "Hours"
                      : formikProps.values.memberShipType === "pt" ||
                        formikProps.values.memberShipType === "class"
                      ? "Sessions"
                      : "Visits"
                  }`}
                </Label>
              </FormGroup>
            </Col>

            <Col md={6} className="mt-4 mb-4 d-inline-flex align-items-center">
              <FormGroup className="checkboxes-list  selction-box" check>
                {gym.type == "gym" ? (
                  <Label check className="container-blk">
                    <Input
                      type="checkbox"
                      id={"unlimitedSessions"}
                      checked={formikProps.values.session === "unlimited"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFieldValue("session", "unlimited");
                        } else {
                          setFieldValue("session", nSessions);
                        }
                      }}
                    />{" "}
                    Unlimited
                    <span className="checkmark"></span>
                  </Label>
                ) : (
                  <Label check className="container-blk">
                    <Input
                      type="checkbox"
                      id={"singleVisitSession"}
                      checked={formikProps.values.session === 1}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setNSessions(1);
                          setFieldValue("session", 1);
                        } else {
                          setNSessions("");
                          setFieldValue("session", "");
                        }
                      }}
                    />{" "}
                    Single Visit
                    <span className="checkmark"></span>
                  </Label>
                )}
              </FormGroup>
            </Col>
          </Row>
        }
        <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y">
          <div className="info-title pb-0">
            <Title title={"Duration"} />
          </div>
          <div className="status-inner-block">
            <div className="status-inner-block">
              <div className="subscription-plan-list-element">
                <div className="radio-perdays-package">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    onChange=""
                  >
                    <Field
                      type="radio"
                      name="duration"
                      id="perDayradio"
                      value="D"
                      className="form-check-input"
                      checked={formikProps.values.duration === "D"}
                      onClick={(e) => {
                        setFieldValue("duration", e.target.value);
                      }}
                    />

                    <label
                      className="form-check-label label-blk"
                      for="perDayradio"
                    >
                      Per days
                    </label>
                  </div>
                </div>
              </div>
              <div className="subscription-plan-list-element">
                <div className="">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    checked
                    onChange=""
                  >
                    <Field
                      type="radio"
                      name="duration"
                      id="perMonthRadio"
                      value="M"
                      className="form-check-input"
                      checked={formikProps.values.duration === "M"}
                      onClick={(e) => setFieldValue("duration", e.target.value)}
                    />
                    <label
                      className="form-check-label label-blk"
                      for="perMonthRadio"
                    >
                      Per months
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="info blk-padding-y pb-0">
            <Row>
              {formikProps.values.duration === "D" ? (
                <Col md={6}>
                  <FormGroup className="custom-inputs with-icon mb-xl-0">
                    <Field
                      type="text"
                      name="days"
                      id="id"
                      placeholder="No of days"
                      className={`form-control ${errors.days &&
                        touched.days &&
                        "is-invalid"}`}
                    />
                    {errors.days && touched.days ? (
                      <div className="invalid-feedback">{`${errors.days}`}</div>
                    ) : null}
                    <Label for="days" className="">
                      Number of days
                    </Label>
                  </FormGroup>
                </Col>
              ) : (
                <Col md={6}>
                  <FormGroup className="custom-inputs with-icon mb-xl-0">
                    <Field
                      type="text"
                      className={`form-control ${errors.days &&
                        touched.days &&
                        "is-invalid"}`}
                      name="days"
                      placeholder="No of Months"
                      onChange={(e) => setFieldValue("days", e.target.value)}
                    ></Field>

                    {errors.days && touched.days ? (
                      <div className="invalid-feedback">{`${errors.days}`}</div>
                    ) : null}
                    <Label for="name" className="">
                      Number of months
                    </Label>
                  </FormGroup>
                </Col>
              )}
            </Row>
          </div>
        </div>
        {gym.type == "gym" && (
          <>
            <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y">
              <div className="info-title pb-0">
                <Title title={"Package Type"} />
              </div>
              <div className="status-inner-block">
                <div className="status-inner-block">
                  <div className="subscription-plan-list-element">
                    <div className="">
                      <div
                        className="form-check form-check-inline custom-btn-radio"
                        checked
                        onChange=""
                      >
                        <Field
                          type="radio"
                          name="mode"
                          id="offline-radio"
                          value="OFFLINE"
                          className="form-check-input no-padding"
                        />
                        <label
                          className="form-check-label label-blk"
                          for="offline-radio"
                        >
                          Offline
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="subscription-plan-list-element">
                    <div className="">
                      <div
                        className="form-check form-check-inline custom-btn-radio"
                        onChange=""
                      >
                        <Field
                          type="radio"
                          name="mode"
                          id="online-radio"
                          value="ONLINE"
                          className="form-check-input"
                        />

                        <label
                          className="form-check-label label-blk"
                          for="online-radio"
                        >
                          Online
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="subscription-plan-list-element">
                    <div className="">
                      <div
                        className="form-check form-check-inline custom-btn-radio"
                        onChange=""
                      >
                        <Field
                          type="radio"
                          name="mode"
                          id="hybrid-radio"
                          className="form-check-input no-padding"
                          value="HYBRID"
                        />

                        <label
                          className="form-check-label label-blk"
                          for="hybrid-radio"
                        >
                          Hybrid
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {errors.mode && touched.mode ? (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  >{`${errors.mode}`}</div>
                ) : null}
              </div>
            </div>
          </>
        )}
        {(gym.type == "sportClub" || gym.type == "complex") &&
          values.memberShipType == "court" && (
            <section>
              <div className="mt-3 mb-4">
                <h1
                  className="blk-padding"
                  style={{ fontSize: "20px", lineHeight: "27px" }}
                >
                  Program Enrollment Settings
                </h1>
              </div>
              <div
                style={{ padding: "0 24px" }}
                className="status-wrapper mt-2 border-bottom-1 pb-4 setting-wrapper"
              >
                <div className="info-title p-0 col-3">
                  <Title title="Free Trial Available" />
                </div>
                <div className="status-inner-block">
                  <div className="time-select-box d-inline-block">
                    <div className="d-flex align-items-center">
                      <div className="switch-wrapper line-switch">
                        <Input
                          type="checkbox"
                          max-width-fit-content
                          id={
                            values.freeTrial
                              ? "switchBox203333"
                              : "editswitchBox203333"
                          }
                          className="switch-input"
                          checked={values.freeTrial}
                          onChange={(e) => {
                            setFieldValue("freeTrial", !values.freeTrial);
                          }}
                        />
                        <Label
                          for={
                            values.freeTrial
                              ? "switchBox203333"
                              : "editswitchBox203333"
                          }
                          className="switch-label"
                        ></Label>
                      </div>
                    </div>
                  </div>
                  <div className="d-inline-block">
                    {values.freeTrial ? (
                      <h3 className="ctf-tx-fifth success">Enabled</h3>
                    ) : (
                      <h3 className="ctf-tx-fifth text-danger">Disabled</h3>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{ padding: "0 24px" }}
                className="status-wrapper mt-2 border-bottom-1 pb-4 setting-wrapper"
              >
                <div className="info-title p-0 col-3">
                  <Title title="Waiting List " />
                </div>
                <div className="status-inner-block">
                  <div className="time-select-box d-inline-block">
                    <div className="d-flex align-items-center">
                      <div className="switch-wrapper line-switch">
                        <Input
                          type="checkbox"
                          max-width-fit-content
                          id={
                            values.waitingList
                              ? "switchBoxWaitingList203333"
                              : "editSwitchBoxWaitingList203333"
                          }
                          className="switch-input"
                          checked={values.waitingList}
                          onChange={(e) => {
                            setFieldValue("waitingList", !values.waitingList);
                          }}
                        />
                        <Label
                          for={
                            values.waitingList
                              ? "switchBoxWaitingList203333"
                              : "editSwitchBoxWaitingList203333"
                          }
                          className="switch-label"
                        ></Label>
                      </div>
                    </div>
                  </div>
                  <div className="d-inline-block">
                    {values.waitingList ? (
                      <h3 className="ctf-tx-fifth success">Enabled</h3>
                    ) : (
                      <h3 className="ctf-tx-fifth text-danger">Disabled</h3>
                    )}
                  </div>
                </div>
              </div>
              {values.waitingList && (
                <div style={{ padding: "0 0 0 24px" }}>
                  <Row
                    className="bg-grey rounded align-items-start mx-0 mb-4"
                    style={{ minHeight: "190px", border: "1px solid #e4e7eb" }}
                  >
                    <Col md={5} className="mt-4">
                      <FormGroup
                        className="custom-inputs select-box mb-md-0 custom-add-sale-input waitListCapacity"
                        style={{ height: "52px" }}
                      >
                        <Input
                          name="waitingListCapacity"
                          type="number"
                          min={0}
                          className={`form-control h-100 ${errors.waitingListCapacity &&
                            touched.waitingListCapacity &&
                            "is-invalid"} d-flex align-items-center`}
                          style={{ color: "black", background: "#F5F7F8 " }}
                          placeholder="Start typing"
                          onChange={(e) =>
                            setFieldValue("waitingListCapacity", e.target.value)
                          }
                        />

                        <Label
                          for="user"
                          className="grey-background"
                          style={{
                            background: "#F5F7F8",
                            mixBlendMode: "normal",
                          }}
                        >
                          How many can waitlist?
                        </Label>
                        {errors.waitingListCapacity ? (
                          <div className="invalid-feedback">{`${errors.waitingListCapacity}`}</div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <div
                        className="subscription-plan-list-element"
                        onClick={() => setFieldValue("waitingListRule", "auto")}
                      >
                        <div className="">
                          <div
                            className="form-check form-check-inline custom-btn-radio pl-0 "
                            id="bg-grey"
                          >
                            <Field
                              className="form-check-input"
                              type="radio"
                              name="auto"
                              id="auto"
                              value={"auto"}
                              checked={values.waitingListRule === "auto"}
                            />
                            <label
                              className="form-check-label label-blk black-radio-fonts waiting-list-label"
                              for="waitingList"
                            >
                              <span className="d-flex">
                                Automatic selection{" "}
                              </span>
                              <small className="ml-1">
                                (Automatically moves members from "Waitlist" to
                                "Booked" based on first come first serve)
                              </small>
                            </label>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={12}>
                      <div
                        className="subscription-plan-list-element"
                        onClick={() => setFieldValue("waitingListRule", "push")}
                      >
                        <div className="">
                          <div
                            className="form-check form-check-inline custom-btn-radio pl-0"
                            id="bg-grey"
                          >
                            <Field
                              className="form-check-input"
                              type="radio"
                              name="push"
                              id="push"
                              value={"push"}
                              checked={values.waitingListRule === "push"}
                            />
                            <label
                              className="form-check-label label-blk black-radio-fonts waiting-list-label"
                              for="waitingList"
                            >
                              <span className="d-flex">Push notification </span>
                              <small className="ml-1">
                                (Class availability notifications are sent to
                                all members on the "Waitlist", the first to
                                confirm is moved to the "booked")
                              </small>
                            </label>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
              <div
                style={{ padding: "0 24px" }}
                className="status-wrapper mt-2 border-bottom-1 pb-4 setting-wrapper"
              >
                <div className="info-title p-0 col-3">
                  <Title title="Allow unpaid booking" />
                </div>
                <div className="status-inner-block">
                  <div className="time-select-box d-inline-block">
                    <div className="d-flex align-items-center">
                      <div className="switch-wrapper line-switch">
                        <Input
                          type="checkbox"
                          max-width-fit-content
                          id={
                            values.allowUnPaidBooking
                              ? "switchBoxAllowUnPaidBooking203333"
                              : "editSwitchBoxAllowUnPaidBooking203333"
                          }
                          className="switch-input"
                          checked={values.allowUnPaidBooking}
                          onChange={(e) => {
                            setFieldValue(
                              "allowUnPaidBooking",
                              !values.allowUnPaidBooking
                            );
                          }}
                        />
                        <Label
                          for={
                            values.allowUnPaidBooking
                              ? "switchBoxAllowUnPaidBooking203333"
                              : "editSwitchBoxAllowUnPaidBooking203333"
                          }
                          className="switch-label"
                        ></Label>
                      </div>
                    </div>
                  </div>
                  <div className="d-inline-block">
                    {values.allowUnPaidBooking ? (
                      <h3 className="ctf-tx-fifth success">Enabled</h3>
                    ) : (
                      <h3 className="ctf-tx-fifth text-danger">Disabled</h3>
                    )}
                  </div>
                </div>
              </div>
              <div style={{ padding: "0 24px" }}>
                <div className="trainer-gender-default-wrapper  pt-4">
                  <div className="info-title  pb-2">
                    <Title title="Booking Window" />
                  </div>
                  <div className="status-wrapper  border-bottom-1 blk-padding-y">
                    <div className="status-inner-block">
                      <div className="time-select-box d-inline-block">
                        <Row className="ml-3 ">
                          <Col md={12}>
                            <FormGroup className="ml-3 mt-0 mb-n2 ">
                              <Label className="ctf-tx-size-fifth">
                                <Input
                                  type="checkbox"
                                  name="in"
                                  checked={values?.disableOnlineBooking}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "disableOnlineBooking",
                                      e.target.checked
                                    );
                                  }}
                                  className="payment-checkbox"
                                />
                                Disable Online Bookings
                              </Label>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ padding: "0 24px" }}>
                <div className="trainer-gender-default-wrapper  blk-padding-y pb-0">
                  <div className="info-title  pb-2">
                    <Title title="Cancellation window" />
                  </div>
                  <div className="status-wrapper  border-bottom-1">
                    <Row
                      className="bg-grey rounded"
                      style={{
                        minHeight: "95px",
                        margin: "0 auto",
                        width: "100%",
                        border: "1px solid #e4e7eb",
                      }}
                    >
                      <Col md={5} className="mt-4">
                        <FormGroup
                          className="custom-inputs select-box mb-md-0 custom-add-sale-input waitListCapacity"
                          style={{ height: "52px" }}
                        >
                          <TextWithSelect
                            onTextChange={(e) => {
                              if (e.target.value <= 99)
                                setFieldValue("cancelBefore", e.target.value);
                            }}
                            options={cancelationOptions}
                            value={values.cancelBefore}
                            onSelectChange={(e) => {
                              setFieldValue(
                                "cancelationWindowUnit",
                                e.target.value
                              );
                            }}
                            sharedClasses="bg-grey"
                            max={99}
                          />

                          <Label
                            for="user"
                            className="grey-background"
                            style={{
                              background: "#F5F7F8",
                              mixBlendMode: "normal",
                            }}
                          >
                            Cancelation closes at
                          </Label>
                          {errors.cancelBefore ? (
                            <div className="invalid-feedback">{`${errors.cancelBefore}`}</div>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </section>
          )}
          {gym.type=="complex"&&
            <Row className="ml-0">
              <Col md={6}>
                <FormGroup className="ml-3 mt-4 mb-n2">
                  <Label>
                    <Input
                      type="checkbox"
                      checked={values?.supportInsurance}
                      onChange={(e) => {
                        setFieldValue("supportInsurance", e.target.checked);
                      }}
                      className="payment-checkbox"
                    />
                    Support Insurance
                  </Label>
                </FormGroup>
              </Col>
            </Row>
          }
      </div>
    </>
  );
};
